export const CALENDAR_GRID_DROP_SNAP_MIDPOINT = 0.5
